export const getIsInternalLink = (link, siteUrl) => {
	const regex = /.*(\.).-*/;
	const isOurSite = link.includes(siteUrl);
	const isExternalLink = regex.test(link);
	return !isExternalLink || isOurSite;
};

export const getLinkKey = (isInternalLink) =>
	isInternalLink ? "internal" : "external";
